export const capitalizeString = (text: string) => {
    if (text) return text.charAt(0).toUpperCase() + text.slice(1)
}
